<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport>

    @if (myConfigService?.myConfig?.showAdmin) {
    <mat-toolbar (click)="drawer.toggle()" class="clickable py-3">{{
      authService.getFullUserName() }}</mat-toolbar>
    }

    @if (myConfigService?.myConfig?.showAdmin) {
    <mat-nav-list class="mt-3 mx-3">
      @if (organizations?.length > 1) {
      <mat-form-field appearance="outline">
        <mat-label>Choose Organisation</mat-label>
        <mat-select (selectionChange)="changeOrganization($event.value)" [(value)]="selectedId">
          @for (organization of organizations; track organization) {
          <mat-option [value]="organization.organizationId">
            {{organization.organizationName}}
          </mat-option>
          }
        </mat-select>
        <mat-icon matSuffix>repeat</mat-icon>
      </mat-form-field>
      }
      @if (myConfigOrganization) {
      <h3 matSubheader>{{myConfigOrganization.name}}</h3>
      <mat-divider></mat-divider>
      @for (module of myConfigOrganization?.config?.modules; track module) {
      @if (module.menu.url != '' && module.name?.toLowerCase() !== 'backoffice24' && module.menu.name?.toLowerCase() !==
      'backoffice24' && myConfigService.hasModuleAccess(module.name, myConfigOrganization,
      this.authService.isAdminOrSiteAdmin())) {
      <mat-list-item [routerLink]="[module.menu.url]" routerLinkActive="router-link-active" (click)="drawer.close()">
        <mat-icon matListItemIcon>{{module.menu.icon}}</mat-icon>
        <div matListItemTitle>{{module.menu.name}}</div>
      </mat-list-item>
      }
      @if (module.menu.url != '' && (module.name?.toLowerCase() === 'backoffice24' || module.menu.name?.toLowerCase()
      === 'backoffice24') && myConfigService.hasModuleAccess(module.name, myConfigOrganization,
      this.authService.isAdminOrSiteAdmin())) {
      <mat-list-item [routerLink]="[module.menu.url]" routerLinkActive="router-link-active" (click)="drawer.close()">
        <mat-icon matListItemIcon>{{module.menu.icon}}</mat-icon>
        <div matListItemTitle>{{module.menu.name}}</div>
      </mat-list-item>
      @for (subModule of (myConfigOrganization?.config?.backOfficeModules || myConfigOrganization?.backOfficeModules);
      track subModule) {
      <mat-list-item
        [routerLink]="['/admin/backoffice24', myConfigOrganization.organizationId, $safeNavigationMigration(subModule.menu?.route)]"
        routerLinkActive="router-link-active" (click)="drawer.close()" class="sub-menu-item">
        <mat-icon matListItemIcon>{{subModule.menu?.icon || 'chevron_right'}}</mat-icon>
        <div matListItemTitle>{{ getBackOfficeModuleName(subModule) }}</div>
      </mat-list-item>
      }
      }
      }
      }
    </mat-nav-list>
    }

  </mat-sidenav>

  <mat-sidenav-content>
    @if (showNavigation) {
    <mat-toolbar>
      <mat-toolbar-row class="custom-toolbar my-3 my-md-1">
        <div class="d-flex flex-row align-items-center">
          @if(showMenu && authService?.loggedIn() && myConfigService?.myConfig?.showAdmin ) {
          @if ((!this.organizations || this.organizations?.length === 0)) {
          <mat-spinner diameter="24" class="mr-2" color="accent"></mat-spinner>
          }
          @if (this.organizations && this.organizations?.length > 0) {
          <button type="button" class="mr-2" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()"
            (touchstart)="drawer.toggle(); $event.preventDefault(); $event.stopPropagation();" matTooltip="Öppna meny">
            <mat-icon class="icon" aria-label="Side nav toggle icon">menu</mat-icon>
          </button>
          }
          }
          @if (showFlygets) {
          <span>
            <img src="../../../assets/img/thumbnail_Flygets-logo.png" alt="flygets logo"
              class="flygets-logo clickable mr-2" [routerLink]="['/flygets/flygets-start']">
          </span>
          }
          @if (showParkifly) {
          <span class="logo-wrapper">
            <span class="mr-2"
              [class.clickable]="myConfigService.hasOrganizationIdRole(organizationId, 'ParkingOperator', organizationId) || myConfigService.hasOrganizationIdRole(organizationId, 'ParkingAdministrator', organizationId)"
              (click)="goToAdminStart()">
              <svg width="140" height="21" viewBox="0 0 158 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_95_3529)">
                  <path
                    d="M0 20.2132V0.567017H13.0762C15.6097 0.567017 17.0924 0.968838 18.0031 1.91599C19.0072 2.94924 19.4508 4.74309 19.4508 7.74239C19.4508 10.2251 19.2874 12.1337 18.4818 13.3822C17.6762 14.6308 16.2518 15.1904 13.8584 15.1904H6.79495V10.8278H12.0371C13.8584 10.8278 14.8391 10.3686 14.8391 7.95766C14.8391 6.69479 14.6173 5.91985 14.1036 5.47498C13.6132 5.0301 12.8894 4.944 11.967 4.944H4.56499V20.2276H0V20.2132Z"
                    fill="#29ABE2" />
                  <path
                    d="M38.4814 20.2132L36.9286 16.5538H26.059L24.4362 20.2132H19.3691L28.2773 0.567017H34.7687L43.49 20.2132H38.4697H38.4814ZM27.5651 12.9087H35.3291L31.4413 4.0973L27.5534 12.9087H27.5651Z"
                    fill="#29ABE2" />
                  <path
                    d="M61.0261 20.2132V18.5485C61.0261 16.3098 60.9211 15.0469 58.6444 15.0469H52.4799V10.6843H58.5043C59.8003 10.6843 60.419 10.5121 60.8043 10.0385C61.2246 9.52189 61.2597 8.66084 61.2597 7.59889C61.2363 6.52258 61.213 5.51803 60.1155 5.13056C59.6135 4.95835 59.0297 4.944 58.6327 4.944H50.0982V10.6843H50.1099V15.0469H50.0982V20.2276H45.5332V0.567017H60.6058C62.6023 0.567017 63.8515 0.968838 64.6571 1.85858C65.4977 2.79138 65.883 4.31256 65.883 6.68044C65.883 8.08681 65.8013 9.55059 65.2292 10.6843C64.7272 11.6171 63.8399 11.9615 62.9759 12.2916C62.8124 12.349 62.649 12.4207 62.4855 12.4781L62.5206 12.9948C64.5637 13.3248 65.6845 13.9993 65.6845 16.5968V20.1989H61.0495L61.0261 20.2132Z"
                    fill="#29ABE2" />
                  <path d="M70.4012 20.2132V0.567017H74.9662V6.35037V6.60868V15.9223V20.2132H70.4012Z" fill="#29ABE2" />
                  <path d="M98.9937 0.567017H94.4287V20.2132H98.9937V0.567017Z" fill="#29ABE2" />
                  <path
                    d="M103.711 20.2132V0.567017H120.056V4.62828H108.264V8.97656H119.18V12.4351H108.264V20.2132H103.711Z"
                    fill="#0583C9" />
                  <path d="M124.084 20.2132V0.567017H128.649V15.6927H138.841V20.2132H124.084Z" fill="#0583C9" />
                  <path
                    d="M144.445 20.2132V13.3679L135.327 0.567017H141.048L146.71 9.04831L152.326 0.567017H158L149.033 13.3679V20.2132H144.445Z"
                    fill="#0583C9" />
                  <path
                    d="M84.75 20.2134L77.5231 12.6649V12.6362L77.4297 12.5501C76.8109 12.0622 76.4373 11.2298 76.4373 10.3257C76.4373 9.42162 76.8109 8.58928 77.4297 8.10135L77.5231 8.0296V8.0009L84.1546 0.552856H90.3775L81.2125 10.2827L91.3699 20.199H84.7384L84.75 20.2134Z"
                    fill="#29ABE2" />
                </g>
                <defs>
                  <clipPath id="clip0_95_3529">
                    <rect width="158" height="19.6462" fill="white" transform="translate(0 0.567017)" />
                  </clipPath>
                </defs>
              </svg>
            </span>
          </span>
          }
        </div>
        @if (showSearch && (authService.isCompanyAdmin('Shuttlebuss') || authService.isSiteAdmin() ||
        authService.isDriver('Flygets.se') || authService.isStaff('Skavsta'))) {
        <form class="d-none d-md-flex search-container" [formGroup]="orderNrForm">
          <mat-form-field class="search-dropdown">
            <mat-select formControlName="searchSelect" placeholder="Typ">
              <mat-option value="O">OrderNr</mat-option>
              <mat-option value="T">TransNr</mat-option>
              <mat-option value="C">CarId</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="search-input">
            <input matInput [value]="$safeNavigationMigration(orderNr?.toUpperCase())" formControlName="orderNr"
              placeholder="{{ 'PARKIFLY.MANAGE_BOOKING.SEARCH' | transloco }}"
              (input)="$event.target.value = $event.target.value.toUpperCase()">
          </mat-form-field>
          <button mat-fab extended color="primary" (click)="getOrderNr()" class="search-button">
            <mat-icon>search</mat-icon>
          </button>
        </form>
        }
        <div class="d-flex flex-row align-items-center">
          <!-- Desktop buttons -->
          @if (showNavButtons) {
          <div class="hidden md:block">
            @if (!authService.loggedIn()) {
            <button
              class="text-sm leading-6 text-[#1B3777] rounded-[4px] px-8 py-2 font-semibold hover:underline bg-white"
              (click)="login()">
              {{"FORM.LOGIN" | transloco}}
            </button>
            }
            <button
              class="text-sm leading-6 text-[#1B3777] rounded-[4px] px-8 py-2 ml-3 font-semibold hover:underline bg-white"
              (click)="goToHandleBooking()">
              {{"PARKIFLY.HOME.MANAGE_BOOKING" | transloco}}
            </button>
          </div>
          }
          <!-- Mobile hamburger menu -->
          @if (showNavButtons && !authService.loggedIn()) {
          <button type="button" class="d-block d-md-none mr-2" mat-icon-button matTooltip="Menu"
            [matMenuTriggerFor]="mobileMenu">
            <mat-icon class="icon">menu</mat-icon>
          </button>
          }
          @if (translate.getActiveLang() === 'en') {
          <button type="button" (click)="translate.setActiveLang('sv')" class="lang-btn" mat-icon-button
            matTooltip="{{ 'ERROR.TOOLTIP' | transloco }}">
            <img width="22" height="22" src="../../../../../assets/img/flag-button-round-250-SV.png">
          </button>
          }
          @if (translate.getActiveLang() === 'sv') {
          <button type="button" (click)="translate.setActiveLang('en')" class="lang-btn" mat-icon-button
            matTooltip="{{ 'ERROR.TOOLTIP' | transloco }}">
            <img width="22" height="22" src="../../../../../assets/img/flag-button-round-250-EN.png">
          </button>
          }
          @if (authService.isCompanyAdmin('Shuttlebuss') || authService.isSiteAdmin()) {
          <button type="button" (click)="openDebug()" class="mr-2" mat-icon-button matTooltip="Debug">
            <mat-icon class="icon">flutter_dash</mat-icon>
          </button>
          }
          @if (authService.loggedIn()) {
          <button type="button" class="mr-2" mat-icon-button
            matTooltip="Inloggad som {{ authService.getFullUserName() }}" [matMenuTriggerFor]="menu">
            <mat-icon class="icon">account_circle</mat-icon>
          </button>
          }
        </div>
        <!-- Mobile menu for non-logged in users -->
        <mat-menu #mobileMenu="matMenu">
          <button mat-menu-item (click)="login()">
            <mat-icon>login</mat-icon>
            <span>{{"FORM.LOGIN" | transloco}}</span>
          </button>
          <button mat-menu-item (click)="goToHandleBooking()">
            <mat-icon>edit</mat-icon>
            <span>{{"PARKIFLY.HOME.MANAGE_BOOKING" | transloco}}</span>
          </button>
        </mat-menu>
        <!-- Account menu for logged in users -->
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="goToHandleBooking()" class="d-block d-md-none">
            <mat-icon>edit</mat-icon>
            <span>{{"PARKIFLY.HOME.MANAGE_BOOKING" | transloco}}</span>
          </button>
          <button mat-menu-item (click)="openSettings()"
            matTooltip="Inställningar för {{ authService.getFullUserName() }}">
            <mat-icon>settings</mat-icon>
            <span>
              {{ 'NAVIGATION.SETTINGS' | transloco }}
            </span>
          </button>
          <button mat-menu-item (click)="logout()" matTooltip="Logga ut">
            <mat-icon>login</mat-icon>
            <span>
              {{ 'NAVIGATION.SIGN_OUT' | transloco }}
            </span>
          </button>
        </mat-menu>
      </mat-toolbar-row>
      @if (showSearch && (authService.isCompanyAdmin('Shuttlebuss') || authService.isSiteAdmin() ||
      authService.isDriver('Flygets.se') || authService.isStaff('Skavsta')) && !showParkiflyHeader()) {
      <mat-toolbar-row class="d-sm-flex d-md-none flex-row align-items-center px-4 pb-3">
        @if (showSearch && (authService.isCompanyAdmin('Shuttlebuss') || authService.isSiteAdmin() ||
        authService.isDriver('Flygets.se') || authService.isStaff('Skavsta'))) {
        <form [formGroup]="orderNrForm" class="d-flex search-container w-100">
          <mat-form-field class="search-dropdown search-dropdown--mobile">
            <mat-select formControlName="searchSelect" placeholder="Typ">
              <mat-option value="O">OrderNr</mat-option>
              <mat-option value="T">TransNr</mat-option>
              <mat-option value="C">CarId</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="search-input">
            <input matInput [value]="$safeNavigationMigration(orderNr?.toUpperCase())" formControlName="orderNr"
              placeholder="{{ 'PARKIFLY.MANAGE_BOOKING.SEARCH' | transloco }}"
              (input)="$event.target.value = $event.target.value.toUpperCase()">
          </mat-form-field>
          <button mat-fab extended color="primary" (click)="getOrderNr()" class="search-button">
            <mat-icon>search</mat-icon>
          </button>
        </form>
        }
      </mat-toolbar-row>
      }
    </mat-toolbar>
    }

    <router-outlet></router-outlet>

  </mat-sidenav-content>
</mat-sidenav-container>